import { DeviceType } from '../enums';

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

let deviceType: DeviceType | null = null;

/**
 * Tablets are checked first because isMobile() matches them too. iPadOS 13+ sends a desktop Safari
 * user agent ("Macintosh"), so it is told apart by its touch screen; Android tablets omit "Mobile".
 */
export const getDeviceType = (): DeviceType => {
  if (deviceType) return deviceType;
  const ua = navigator.userAgent;
  const isIPadOS = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
  const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);
  if (isIPadOS || isAndroidTablet || /iPad|Tablet|PlayBook|Silk/i.test(ua)) {
    deviceType = DeviceType.Tablet;
  } else {
    deviceType = isMobile() ? DeviceType.Mobile : DeviceType.Desktop;
  }
  return deviceType;
};
